/* Sweetmess — logika teme.
   Vanilla JS, bez ovisnosti. Radi na Shopify Cart AJAX API-ju.

   Granica povjerenja, jer se innerHTML koristi na tri mjesta:

   1. Traka dostave — predložak dolazi iz našeg locale datoteke (Liquid),
      a jedina promjenjiva vrijednost (iznos) ide kroz esc().
   2. Bočna košarica i prijedlozi tražilice — HTML dolazi iz Section
      Rendering API-ja, dakle iz našeg vlastitog Liquida s istog porijekla.

   Upit koji piše kupac nikad se ne sastavlja ovdje — ispisuje ga Liquid,
   i tamo MORA ići kroz `| escape`. Liquid ne bježi automatski. */
(function () {
  'use strict';

  var sm = window.sm || {};
  var rute = sm.rute || {};

  // ---------------------------------------------------------- pomoćno

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Novac. Shopify računa u centima.

     JEDAN IZVOR OBLIKA. Dosad je ovdje stajao `Intl.NumberFormat('hr-HR')`,
     koji za EUR daje „7,50 €” — a Liquidov filtar `| money` poštuje oblik
     upisan u administraciji trgovine, koji je ovdje „€7,50”. Rezultat je bio
     da su na SVIH 39 stranica proizvoda dvije cijene u dva oblika jedna do
     druge: raspon iznad („€6,50 – €7,50”, Liquid) i cijena odabrane varijante
     ispod („7,50 €”, JS). Isto se događalo u traci besplatne dostave.

     Sada JS koristi isti oblik kao Liquid (`shop.money_format`, prenesen kroz
     `window.sm.oblikNovca`), pa promjena postavke u administraciji mijenja
     oboje odjednom. Implementacija je Shopifyjev vlastiti skup zamjenskih
     oznaka — sve četiri osnovne plus one s razmakom i apostrofom, jer trgovina
     smije promijeniti oblik bez da itko dira temu. */
  function grupiraj(iznos, decimalni, tisucni, decimala) {
    var s = decimala === 0 ? String(Math.round(iznos)) : iznos.toFixed(decimala);
    var dio = s.split('.');
    var cijeli = dio[0].replace(/\B(?=(\d{3})+(?!\d))/g, tisucni);
    return decimala === 0 ? cijeli : cijeli + decimalni + dio[1];
  }

  function novac(centi) {
    var iznos = (centi || 0) / 100;
    var oblik = sm.oblikNovca || '{{amount_with_comma_separator}} €';
    return oblik.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, oznaka) {
      switch (oznaka) {
        case 'amount': return grupiraj(iznos, '.', ',', 2);
        case 'amount_no_decimals': return grupiraj(iznos, '.', ',', 0);
        case 'amount_with_comma_separator': return grupiraj(iznos, ',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return grupiraj(iznos, ',', '.', 0);
        case 'amount_with_apostrophe_separator': return grupiraj(iznos, '.', "'", 2);
        case 'amount_with_space_separator': return grupiraj(iznos, ',', ' ', 2);
        case 'amount_no_decimals_with_space_separator': return grupiraj(iznos, ',', ' ', 0);
        case 'amount_with_period_and_space_separator': return grupiraj(iznos, '.', ' ', 2);
        default: return '';
      }
    });
  }

  function $(sel, kontekst) { return (kontekst || document).querySelector(sel); }
  function $$(sel, kontekst) { return Array.prototype.slice.call((kontekst || document).querySelectorAll(sel)); }

  function objavi(ime, detalj) {
    document.dispatchEvent(new CustomEvent(ime, { detail: detalj }));
  }

  /* ---------------------------------------------------------- zamka fokusa

     Tri sloja preko sadržaja — bočna košarica, mobilni izbornik i panel
     tražilice — imaju `role="dialog"` i `aria-modal="true"`, ali Tab je iz njih
     izlazio na sadržaj iza (izmjereno: iz otvorene ladice peti Tab završi na
     `a.preskoci-na-sadrzaj`), a Escape ih je zatvarao bez vraćanja fokusa na
     gumb koji ih je otvorio. `aria-modal` je samo obećanje čitaču ekrana —
     preglednik po njemu ne mijenja tab-redoslijed, to mora učiniti tema.

     `zamka(panel)` vraća funkciju koja zamku otpušta i vraća fokus onamo
     odakle je došao. Popis fokusabilnih elemenata čita se pri svakom Tabu,
     jer se sadržaj ladice mijenja (Section Rendering API). */
  var FOKUSABILNI = 'a[href], button:not([disabled]), input:not([disabled]),'
    + ' select:not([disabled]), textarea:not([disabled]), summary,'
    + ' [tabindex]:not([tabindex="-1"])';

  function fokusabilni(panel) {
    return $$(FOKUSABILNI, panel).filter(function (el) {
      return !el.hasAttribute('hidden') && el.offsetParent !== null;
    });
  }

  /* Stog aktivnih zamki. Dva sloja mogu biti otvorena istodobno (izmjereno:
     otvoren mobilni izbornik pa otvoren panel tražilice ostavlja oba), a dvije
     zamke na `document` obje reagiraju na isti Tab — donja bi vidjela fokus
     izvan svog panela i otela ga natrag, pa bi se fokus vrtio između slojeva.
     Djeluje zato samo zamka na vrhu stoga; ostale miruju dok se ne otpuste. */
  var zamke = [];

  function zamka(panel, prviFokus) {
    var otvarac = document.activeElement;
    var zapis = { panel: panel };
    zamke.push(zapis);

    function naTab(e) {
      if (e.key !== 'Tab') return;
      if (zamke[zamke.length - 1] !== zapis) return;
      var popis = fokusabilni(panel);
      if (!popis.length) return;
      var prvi = popis[0];
      var zadnji = popis[popis.length - 1];
      if (!panel.contains(document.activeElement)) {
        e.preventDefault();
        (e.shiftKey ? zadnji : prvi).focus();
      } else if (e.shiftKey && document.activeElement === prvi) {
        e.preventDefault();
        zadnji.focus();
      } else if (!e.shiftKey && document.activeElement === zadnji) {
        e.preventDefault();
        prvi.focus();
      }
    }

    document.addEventListener('keydown', naTab, true);
    var cilj = prviFokus || fokusabilni(panel)[0];
    if (cilj) cilj.focus();

    return function otpusti() {
      document.removeEventListener('keydown', naTab, true);
      var mjesto = zamke.indexOf(zapis);
      if (mjesto !== -1) zamke.splice(mjesto, 1);
      // Fokus se vraća samo ako je ostao unutar panela — ako je kupac u
      // međuvremenu kliknuo drugdje, ne otimamo mu ga natrag.
      if (otvarac && document.contains(otvarac) && (!document.activeElement || panel.contains(document.activeElement) || document.activeElement === document.body)) {
        otvarac.focus();
      }
    };
  }

  function zahtjev(url, opcije) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opcije))
      .then(function (r) {
        return r.json().then(function (t) {
          if (!r.ok) throw Object.assign(new Error(t.description || t.message || 'Greška'), { podaci: t });
          return t;
        });
      });
  }

  // ---------------------------------------------------------- košarica

  var Kosarica = {
    stanje: null,

    dohvati: function () {
      return zahtjev(rute.kosarica + '.js').then(function (k) {
        Kosarica.stanje = k;
        objavi('kosarica:promjena', k);
        return k;
      });
    },

    /* Shopify prima više stavki u jednom pozivu i dodaje ih ATOMSKI: padne li
       jedna, ne doda se nijedna. To je ovdje bitno — uložak bez nadoplate
       kupac plati premalo, nadoplata bez uloška je 0,50 € niotkuda. */
    dodajStavke: function (stavke) {
      return zahtjev(rute.dodaj + '.js', { method: 'POST', body: JSON.stringify({ items: stavke }) })
        .then(function () { return Kosarica.dohvati(); });
    },

    dodaj: function (id, kolicina, svojstva) {
      var stavka = { id: id, quantity: kolicina || 1 };
      if (svojstva) stavka.properties = svojstva;
      return Kosarica.dodajStavke([stavka]);
    },

    promijeni: function (kljuc, kolicina) {
      return zahtjev(rute.promijeni + '.js', {
        method: 'POST', body: JSON.stringify({ id: kljuc, quantity: kolicina }),
      }).then(function (k) {
        Kosarica.stanje = k;
        objavi('kosarica:promjena', k);
        return k;
      });
    },
  };

  window.smKosarica = Kosarica;

  // ---------------------------------------------------------- brojač u zaglavlju

  /* Brojka BEZ redaka nadoplate.

     „Nepropusni materijal” je zaseban redak košarice iz tehničkih razloga
     (uložak je već potrošio sve tri Shopifyjeve opcije), ali kupcu nije drugi
     artikl i u košarici mu se redak ne crta — vidi
     `sections/kosarica-ladica.liquid`. `cart.item_count` broji sve retke, pa
     bi brojač pokazivao 3 nad popisom od dva artikla.

     Isto pravilo stoji i u `snippets/kosarica-broj.liquid`, za prvo crtanje
     stranice. Mijenja li se ovdje, mijenja se i ondje. */
  function brojArtikala(k) {
    if (!k || !k.items) return 0;
    return k.items.reduce(function (zbroj, s) {
      if (s.properties && s.properties._nadoplata_uz) return zbroj;
      return zbroj + s.quantity;
    }, 0);
  }

  function osvjeziBrojac(k) {
    var broj = brojArtikala(k);
    $$('[data-broj-kosarice]').forEach(function (el) {
      el.textContent = broj;
      el.hidden = broj === 0;
    });
  }

  // ---------------------------------------------------------- traka besplatne dostave

  function crtajTrakuDostave(k) {
    var prag = sm.pragBesplatneDostave || 0;
    if (!prag) return;

    $$('[data-traka-dostave]').forEach(function (el) {
      var iznos = k.total_price || 0;
      var fali = prag - iznos;
      var posto = Math.max(0, Math.min(100, (iznos / prag) * 100));

      if (k.item_count === 0) { el.innerHTML = ''; return; }

      if (fali <= 0) {
        el.innerHTML = '<div class="sm-dostava je-ostvarena">'
          + '<p class="sm-dostava__tekst"><strong>' + esc(el.getAttribute('data-tekst-ostvareno') || '') + '</strong></p>'
          + '<div class="sm-dostava__sina"><span class="sm-dostava__ispuna" style="width:100%"></span></div></div>';
      } else {
        var predlozak = el.getAttribute('data-tekst-jos') || '';
        el.innerHTML = '<div class="sm-dostava">'
          + '<p class="sm-dostava__tekst">' + predlozak.replace('{{ iznos }}', '<strong>' + esc(novac(fali)) + '</strong>') + '</p>'
          + '<div class="sm-dostava__sina"><span class="sm-dostava__ispuna" style="width:' + posto.toFixed(1) + '%"></span></div></div>';
      }
    });
  }

  // ---------------------------------------------------------- bočna košarica

  // ------------------------------------------------- vidljivo okno zaslona

  /* KOLIKO JE ZASLONA STVARNO VIDLJIVO, U PIKSELIMA (22. 8. 2026.).

     Nastavak prijave „gumbi nisu zaključani i slobodno se miču”. Brava pomaka
     je zaustavila stranicu, ali je otkrila drugi kvar, i to onaj koji je
     klijent i snimio: na jednoj snimci adresna traka preglednika stoji, na
     drugoj je nema — i baš na toj drugoj ispod „Prikaži košaricu” zjapi
     prazna traka visoka otprilike koliko i ta adresna traka.

     Uzrok je razlika između dva okvira koja mobilni preglednik drži odvojeno:
       · LAYOUT viewport — prema njemu se računa `position: fixed`;
       · VISUAL viewport — ono što oko stvarno vidi.
     Kad se adresna traka uvuče, vidljivo okno naraste, ali layout okvir ne
     mora; a čim stranicu zaključamo (`html { overflow: hidden }`), Chrome na
     Androidu layout okvir računa kao da traka STOJI — jer stranica koja se ne
     može pomicati traku i ne može sakriti. Ladica je `position: fixed` uz dno
     tog okvira, pa je završila iznad stvarnog dna zaslona, i ostavila prazan
     pojas točno visine trake. Otud i „ponekad”: događa se samo kad se ladica
     otvori dok je traka već uvučena.

     `visualViewport` je jedini izvor koji uvijek zna pravu mjeru. Iz njega
     ovdje ispisujemo dvije varijable, a `sm-kosarica.css` po njima na
     telefonu razapinje ladicu. Prati se i `resize` i `scroll`: prvi javlja
     promjenu visine, drugi pomak okna (npr. dok je otvorena tipkovnica).

     Varijable stoje na `documentElement` i osvježavaju se stalno, ne samo
     dok je ladica otvorena — jeftinije je od vezanja i odvezivanja slušača,
     a vrijednost je točna već u trenutku otvaranja. */
  function pratiVidljivoOkno() {
    var vv = window.visualViewport;
    if (!vv) return;
    var korijen = document.documentElement;

    function osvjezi() {
      korijen.style.setProperty('--sm-okno-visina', vv.height + 'px');
      korijen.style.setProperty('--sm-okno-vrh', vv.offsetTop + 'px');
    }

    vv.addEventListener('resize', osvjezi);
    vv.addEventListener('scroll', osvjezi);
    osvjezi();
  }

  // ---------------------------------------------------------- brava pomaka

  /* ZAŠTO `body { overflow: hidden }` NIJE DOVOLJNO (22. 8. 2026.).

     Ladica, mobilni izbornik i panel tražilice svi su gasili pomak stranice
     tako što su body-ju postavili `overflow: hidden`. Na stolnom računalu to
     radi. Na telefonu ne radi ništa: iOS Safari tu deklaraciju za dodir
     jednostavno ignorira, a na Androidu pomak vodi `html`, ne `body`.

     Posljedica je bila prijavljena kao kvar ladice: „gumbi se miču gore-dolje
     kad skrolam, a ‚Prikaži košaricu’ nestane iz vidnog polja”. Stranica IZA
     otvorene ladice i dalje se pomicala; svaki pomak uvlači i izvlači
     preglednikovu adresnu traku, a s njom se seli i dno vidljivog prostora.
     Ladica je `position: fixed` uz to dno, pa je putovala s njim. Nije se
     „otkačila” — nikad nije ni bila zaključana.

     Jedini način koji drži na oba sustava je body u `position: fixed` s
     negativnim `top` koji pamti gdje je stranica stala; pri otpuštanju se
     pomak vraća. Zaključavanje se BROJI, jer se panela može otvoriti više
     (izbornik pa ladica): dok je bilo koji otvoren, brava stoji, a prvi koji
     se zatvori više ne otključava stranicu ispod ostalih.

     `scrollbar-gutter: stable` na `html` (sm-osnova.css) drži širinu
     jednakom dok brava traje — bez toga stolni preglednik na zaključavanju
     izgubi traku za pomak i cijela stranica poskoči ulijevo. */
  var bravaBrojac = 0;
  var bravaPomak = 0;

  function zakljucajPomak() {
    bravaBrojac += 1;
    if (bravaBrojac > 1) return;
    bravaPomak = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.top = '-' + bravaPomak + 'px';
    document.documentElement.classList.add('sm-bez-pomaka');
  }

  function otkljucajPomak() {
    if (bravaBrojac === 0) return;
    bravaBrojac -= 1;
    if (bravaBrojac > 0) return;
    document.documentElement.classList.remove('sm-bez-pomaka');
    document.body.style.top = '';
    /* `scroll-behavior: smooth` s `html` bi ovaj povratak animirao — kupac
       bi vidio kako stranica klizi natrag na mjesto s kojeg se nije ni
       maknula. Zato skok, pa vraćanje ponašanja. */
    var staro = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, bravaPomak);
    document.documentElement.style.scrollBehavior = staro;
  }

  // ---------------------------------------------------------- ladica

  function ladica() {
    var el = $('[data-kosarica-ladica]');
    if (!el) return;

    var otpustiZamku = null;
    /* `hidden` se postavlja tek 300 ms nakon zatvaranja, koliko traje prijelaz.
       Straža na `hidden` zato bi u tom prozoru odbila ponovno otvaranje, a
       zaostali timer bi ladicu svejedno sakrio — ikona košarice bi 300 ms
       izgledala mrtvo. Straža ide na razred koji stvarno znači „otvorena”, a
       timer se pri otvaranju poništava. */
    var timerSkrivanja = null;

    function otvori() {
      if (el.classList.contains('je-otvorena')) return;
      if (timerSkrivanja) { clearTimeout(timerSkrivanja); timerSkrivanja = null; }
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('je-otvorena'); });
      zakljucajPomak();
      var panel = $('[data-panel-ladice]', el) || el;
      otpustiZamku = zamka(panel, $('[data-zatvori-ladicu]', el));
    }

    function zatvori() {
      if (el.hidden) return;
      el.classList.remove('je-otvorena');
      otkljucajPomak();
      if (otpustiZamku) { otpustiZamku(); otpustiZamku = null; }
      if (timerSkrivanja) clearTimeout(timerSkrivanja);
      timerSkrivanja = setTimeout(function () { el.hidden = true; timerSkrivanja = null; }, 300);
    }

    window.smOtvoriLadicu = otvori;

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-zatvori-ladicu]') || e.target.hasAttribute('data-zastor')) zatvori();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !el.hidden) zatvori();
    });

    $$('[data-otvori-kosaricu]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        e.preventDefault();
        Kosarica.dohvati().then(otvori);
      });
    });
  }

  // ---------------------------------------------------------- napomena u ladici

  /* NAPOMENA UZ NARUDŽBU MORA PREŽIVJETI PONOVNO CRTANJE PANELA (28. 8. 2026.).

     Polje stoji unutar forme prema blagajni i zove se `note`, pa ga sam POST
     na `/cart` nosi i bez JavaScripta. Ali ladica se nakon svake promjene
     košarice crta nanovo iz Liquida (`osvjeziLadicu`), a `innerHTML` briše
     upisani tekst: kupica napiše napomenu, klikne „+” na količini i tekst
     nestane bez riječi. Zato se sprema u međuvremenu — istim ritmom kao na
     stranici košarice (500 ms nakon zadnje tipke), i uvijek prije osvježenja.

     Što je trgovina već primila čita se iz `defaultValue`: to je vrijednost
     koju je ispisao Liquid, pa se nakon svakog ponovnog crtanja sama poklopi
     sa stanjem na serveru i ne treba je pamtiti sa strane. Zahtjev ide samo
     kad se `value` od nje razlikuje — inače bi svako otvaranje ladice slalo
     nepotrebni POST. */
  var napomenaUTijeku = null;

  function spremiNapomenuLadice() {
    var polje = $('[data-napomena-ladice]');
    if (!polje || polje.value === polje.defaultValue) return Promise.resolve();

    // Dva spremanja odjednom (odbroj istekne točno dok kupica klika „+”) poslala
    // bi isti tekst dvaput; drugo čeka prvo pa provjeri treba li još ići.
    if (napomenaUTijeku) return napomenaUTijeku.then(spremiNapomenuLadice);

    var vrijednost = polje.value;
    napomenaUTijeku = zahtjev(rute.osvjezi + '.js', {
      method: 'POST',
      body: JSON.stringify({ note: vrijednost }),
    }).then(function () {
      polje.defaultValue = vrijednost;
      /* Na `/cart` polje postoji dvaput — u ladici i na stranici. Bez ovoga
         bi stranica pokazivala stariji tekst i djelovala kao da napomena
         nije spremljena. */
      var naStranici = $('[data-napomena-kosarice]');
      if (naStranici && naStranici.value !== vrijednost) {
        naStranici.value = vrijednost;
        naStranici.defaultValue = vrijednost;
      }
    }).catch(function () {
      // Pao je zahtjev: `defaultValue` ostaje star, pa sljedeći pokušaj šalje opet.
    }).then(function () {
      napomenaUTijeku = null;
    });

    return napomenaUTijeku;
  }

  /* Sluša se na dokumentu, ne na polju: panel se zamjenjuje cijeli, pa
     osluhšivanje zakačeno za sam textarea nestane s prvim osvježenjem. */
  function napomenaLadice() {
    var timer;

    document.addEventListener('input', function (e) {
      if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-napomena-ladice')) return;
      clearTimeout(timer);
      timer = setTimeout(spremiNapomenuLadice, 500);
    });

    // Odlazak iz polja ne čeka odbroj — kupica ga tada obično i zatvara.
    document.addEventListener('focusout', function (e) {
      if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-napomena-ladice')) return;
      clearTimeout(timer);
      spremiNapomenuLadice();
    });
  }

  // Ladica se osvježava dohvaćanjem gotovog HTML-a iz sekcije — tako
  // ostaje jedan izvor istine za izgled (Liquid), a ne dva.
  function osvjeziLadicu() {
    var el = $('[data-kosarica-ladica]');
    if (!el) return Promise.resolve();
    /* Prvo napomena, pa dohvat: `innerHTML` niže dolje briše polje, a
       osvježeni HTML donosi natrag ono što trgovina zna. Sve što mijenja
       košaricu prolazi ovuda, pa je ovo jedina točka koju treba pokriti. */
    return spremiNapomenuLadice().then(function () {
      return fetch(rute.kosarica + '?section_id=kosarica-ladica')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var novo = new DOMParser().parseFromString(html, 'text/html');

          /* Mijenja se CIJELI panel, ne samo unutarnji sadržaj.
             Podnožje s gumbom „Kreni na plaćanje” i brojač su izvan
             [data-sadrzaj-ladice]; dok se osvježavao samo taj div, dodavanje u
             praznu košaricu davalo je ladicu bez puta prema blagajni. (Do
             22. 8. 2026. isto je vrijedilo i za međuzbroj, koji je otad
             maknut iz ladice — vidi `sections/kosarica-ladica.liquid`.) */
          var izvor = novo.querySelector('[data-panel-ladice]');
          var cilj = $('[data-panel-ladice]', el);
          if (izvor && cilj) {
            var bioJeFokus = cilj.contains(document.activeElement);
            cilj.innerHTML = izvor.innerHTML;
            // innerHTML briše element na kojem je bio fokus — vrati ga na zatvaranje.
            if (bioJeFokus) {
              var zatvori = $('[data-zatvori-ladicu]', cilj);
              if (zatvori) zatvori.focus();
            }
          }
        })
        .catch(function () {});
    });
  }

  // ---------------------------------------------------------- dodavanje u košaricu

  /* Svojstva stavke (npr. „Upišite ime” na personaliziranom ručniku).
     Šaljemo ih samo kad su popunjena — prazan upis inače uđe u narudžbu
     kao svojstvo bez vrijednosti i razdvoji dvije inače jednake stavke
     u zasebne retke košarice. */
  function svojstvaForme(forma) {
    var svojstva = {};
    var ima = false;
    $$('[name^="properties["]', forma).forEach(function (polje) {
      if (polje.type === 'checkbox' && !polje.checked) return;
      var naziv = polje.name.slice('properties['.length, -1);
      var vrijednost = (polje.value || '').trim();
      if (!naziv || !vrijednost) return;
      svojstva[naziv] = vrijednost;
      ima = true;
    });
    return ima ? svojstva : null;
  }

  /* ŠTO FORMA PROIZVODA STVARNO DODAJE U KOŠARICU.

     Jedan redak, i dva ga mjesta čitaju jednako („Dodaj u košaricu” i
     „Kupi odmah”). Od 20. 8. do 8. 9. 2026. kvačica nadoplate dodavala je
     i DRUGI redak (skriveni proizvod `nepropusni-materijal`); od 8. 9.
     nadoplata je vrijednost opcije „Materijal” („Pamuk + nepropusni sloj”),
     pa je kvačica dio odabira varijante (vidi `dodatakForme`) i ovdje više
     nema što dodati. Sparivanje po `_nadoplata_uz` u košarici ostaje samo
     zbog redaka dodanih prije te izmjene.

     Vraća `null` ako forma nema varijantu, pa pozivatelj odustaje isto kao
     i prije. */
  function stavkeIzForme(forma) {
    var idPolje = $('[name="id"]', forma);
    var kolPolje = $('[name="quantity"]', forma);
    if (!idPolje || !idPolje.value) return null;

    var kolicina = parseInt(kolPolje ? kolPolje.value : 1, 10) || 1;
    var stavke = [{ id: idPolje.value, quantity: kolicina }];
    var svojstva = svojstvaForme(forma);
    if (svojstva) stavke[0].properties = svojstva;

    return stavke;
  }

  function forme() {
    document.addEventListener('submit', function (e) {
      var forma = e.target.closest('[data-forma-dodaj]');
      if (!forma) return;
      e.preventDefault();

      var gumb = $('[data-gumb-dodaj]', forma);
      var idPolje = $('[name="id"]', forma);
      if (!idPolje || !idPolje.value) return;

      var stariTekst = gumb ? gumb.textContent : '';
      if (gumb) { gumb.disabled = true; gumb.textContent = '…'; }

      Kosarica.dodajStavke(stavkeIzForme(forma))
        .then(function () {
          if (gumb) {
            gumb.textContent = (sm.tekst && sm.tekst.dodano) || 'Dodano';
            setTimeout(function () { gumb.textContent = stariTekst; gumb.disabled = false; }, 1400);
          }
          return osvjeziLadicu().then(function () {
            var nacin = forma.getAttribute('data-nakon-dodavanja') || 'ladica';
            if (nacin === 'ladica' && window.smOtvoriLadicu) window.smOtvoriLadicu();
            else if (nacin === 'stranica') window.location.href = rute.kosarica;
          });
        })
        .catch(function (err) {
          if (gumb) { gumb.textContent = stariTekst; gumb.disabled = false; }
          var greska = $('[data-greska-forme]', forma);
          if (greska) { greska.textContent = err.message; greska.hidden = false; }
        });
    });
  }

  // ---------------------------------------------------------- izmjena količine u košarici

  /* Retci nadoplate koji pripadaju danom retku košarice.

     Traži se po ID-u VARIJANTE, ne po ključu retka: ključ ovisi o svojstvima,
     a isti uložak s istom kvačicom Shopify ionako spaja u jedan redak.

     Popis se mora pokupiti PRIJE promjene roditelja — nakon uklanjanja njega
     u košarici više nema, pa se ne bi imalo iz čega izračunati koja je
     nadoplata bila njegova. */
  function nadoplateUz(kljucRoditelja) {
    var stanje = Kosarica.stanje;
    if (!stanje || !stanje.items) return [];
    var roditelj = null;
    stanje.items.forEach(function (s) { if (s.key === kljucRoditelja) roditelj = s; });
    if (!roditelj) return [];
    var vid = String(roditelj.variant_id);
    return stanje.items.filter(function (s) {
      return s.properties && String(s.properties._nadoplata_uz) === vid;
    });
  }

  function kolicineUKosarici() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-kosarica-promjena]');
      if (!t) return;
      e.preventDefault();
      var kljuc = t.getAttribute('data-kljuc');
      var kolicina = parseInt(t.getAttribute('data-kosarica-promjena'), 10);
      var pratioci = nadoplateUz(kljuc);
      t.disabled = true;
      Kosarica.promijeni(kljuc, kolicina).then(function () {
        /* Nadoplata nema vlastitu količinu — ona je uvijek količina uloška.
           Ide u nizu, jedna za drugom: svaki `promijeni` vraća novo stanje
           košarice, pa se ne smiju slati usporedno. */
        return pratioci.reduce(function (lanac, stavka) {
          return lanac.then(function () { return Kosarica.promijeni(stavka.key, kolicina); });
        }, Promise.resolve());
      }).then(function () {
        return osvjeziLadicu();
      }).then(function () {
        if (document.body.classList.contains('predlozak-cart')) window.location.reload();
      });
    });
  }

  // ---------------------------------------------------------- stranica košarice

  /* Dvije stvari koje postoje samo na /cart:

     1. Napomena uz narudžbu. Sprema se sama, 500 ms nakon zadnje tipke —
        istim ritmom kojim je stara stranica spremala količinu. Bez toga bi
        se tekst izgubio kad promjena količine osvježi stranicu.
     2. Zastor preko tablice i sažetka dok traje zahtjev. Stara stranica je
        za to imala blockUI (bijelo, opacity .6); ovdje je to klasa. */
  function stranicaKosarice() {
    var korijen = $('[data-stranica-kosarice]');
    if (!korijen) return;

    var obrada = $('[data-kosarica-obrada]', korijen);
    var polje = $('[data-napomena-kosarice]', korijen);
    var timer;
    var zadnja = polje ? polje.value : '';

    function spremiNapomenu() {
      if (!polje || polje.value === zadnja) return;
      zadnja = polje.value;
      zahtjev(rute.osvjezi + '.js', {
        method: 'POST',
        body: JSON.stringify({ note: zadnja }),
      }).catch(function () {});
    }

    function zastor() {
      if (!obrada) return;
      obrada.classList.add('je-u-obradi');
      // Ako zahtjev padne, zastor ne smije ostati zauvijek.
      setTimeout(function () { obrada.classList.remove('je-u-obradi'); }, 6000);
    }

    korijen.addEventListener('click', function (e) {
      if (!e.target.closest('[data-kosarica-promjena]')) return;
      clearTimeout(timer);
      spremiNapomenu();
      zastor();
    });

    /* Broj upisan rukom mora se spremiti isto kao klik na +/−. Stara je
       stranica to radila sama (change → 500 ms → AJAX); bez ovoga bi kupac
       upisao 3, vidio stari međuzbroj i mislio da se ništa nije dogodilo.

       ISTO MORA VRIJEDITI I ZA NADOPLATU (ispravljeno 22. 8. 2026.). Klik na
       +/− prolazi kroz `kolicineUKosarici`, koji uz stavku povuče i njezine
       `nadoplateUz`. Ovaj put to nije radio, pa je upis broja rukom mijenjao
       samo redak uloška: 5 uložaka × 2,50 € + nadoplata koja je ostala na 1 ×
       0,50 € = 13,00 € umjesto 15,00 €. Kupica dobije pet nepropusnih uložaka,
       a plati nadoplatu za jedan. */
    $$('[data-kolicina-kosarice]', korijen).forEach(function (broj) {
      broj.addEventListener('change', function () {
        var kljuc = broj.getAttribute('data-kljuc');
        var kolicina = parseInt(broj.value, 10);
        if (!kljuc || isNaN(kolicina) || kolicina < 0) return;
        var pratioci = nadoplateUz(kljuc);
        clearTimeout(timer);
        spremiNapomenu();
        zastor();
        Kosarica.promijeni(kljuc, kolicina)
          .then(function () {
            /* U nizu, ne usporedno — svaki `promijeni` vraća novo stanje
               košarice i ključevi se pomiču ako se šalju paralelno. */
            return pratioci.reduce(function (lanac, stavka) {
              return lanac.then(function () { return Kosarica.promijeni(stavka.key, kolicina); });
            }, Promise.resolve());
          })
          .then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      });
    });

    if (!polje) return;

    polje.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(spremiNapomenu, 500);
    });

    polje.addEventListener('blur', function () {
      clearTimeout(timer);
      spremiNapomenu();
    });
  }

  // ---------------------------------------------------------- steperi

  function steperi() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-kolicina-manje],[data-kolicina-vise]');
      if (!t) return;
      var omot = t.closest('.sm-kolicina');
      var polje = $('input', omot);
      if (!polje) return;
      var v = parseInt(polje.value, 10) || 1;
      var min = parseInt(polje.min, 10) || 1;
      polje.value = t.hasAttribute('data-kolicina-manje') ? Math.max(min, v - 1) : Math.min(999, v + 1);
      polje.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // ---------------------------------------------------------- ukupno za količinu

  /* „3 komada × 5,00 € = 15,00 €” uz sam gumb (22. 8. 2026.).

     Klijentica je javila da se „cijena ne mijenja kad kupac promijeni
     količinu”. Velika cijena na vrhu kutije je i ostaje CIJENA KOMADA — uz
     nju stoje zakonska napomena „Cijena sa PDV-om” i widget „Cijena po
     komadu”, pa se ne smije pretvoriti u međuzbroj. Umjesto toga, ispod
     odabira stoji redak koji kaže što će se stvarno platiti.

     RAČUN JE ISTI ONAJ KOJI VODI KOŠARICA: cijena razriješene varijante puta
     količina. Kvačica „Nepropusni materijal” od 8. 9. 2026. bira skuplju
     varijantu, pa je nadoplata već u cijeni varijante i ovdje se ništa ne
     pribraja.

     ŠUTI KAD NEMA ŠTO REĆI. Dok varijanta nije razriješena (kupac još bira
     boju) cijene nema — ne izmišlja se iznos za nešto što se još ne može
     kupiti. Kod količine 1 redak se skriva, jer bi doslovno ponovio cijenu
     dvjestotinjak piksela iznad.

     Jednostavan proizvod nema `[data-varijante-json]` (blok „Varijante” se
     kod `has_only_default_variant` uopće ne crta), pa cijena tada dolazi iz
     `data-cijena` na samom retku. */
  function ukupnoZaKolicinu() {
    if (!$('[data-ukupno]')) return;

    function cijenaKomada(forma, ispis) {
      var podaciEl = $('[data-varijante-json]', forma);

      if (podaciEl) {
        var idPolje = $('[name="id"]', forma);
        if (!idPolje || !idPolje.value) return null;
        var varijante;
        try { varijante = JSON.parse(podaciEl.textContent); } catch (err) { return null; }
        var nadena = null;
        varijante.forEach(function (v) {
          if (String(v.id) === String(idPolje.value)) nadena = v;
        });
        return nadena && nadena.dostupna ? nadena.cijena : null;
      }

      var zadana = parseInt(ispis.getAttribute('data-cijena'), 10);
      return isNaN(zadana) ? null : zadana;
    }

    function osvjezi() {
      $$('[data-ukupno]').forEach(function (ispis) {
        var forma = ispis.closest('form');
        if (!forma) { ispis.hidden = true; return; }

        var kolPolje = $('[name="quantity"]', forma);
        var kolicina = parseInt(kolPolje ? kolPolje.value : 1, 10) || 1;
        if (kolicina < 1) kolicina = 1;

        var komad = cijenaKomada(forma, ispis);
        if (komad === null || kolicina < 2) { ispis.hidden = true; return; }

        var poKomadu = komad;
        var rijec = hrvatskiOblik(
          kolicina,
          ispis.getAttribute('data-jednina') || '',
          ispis.getAttribute('data-malo') || '',
          ispis.getAttribute('data-mnozina') || ''
        );

        /* Dva polja, kao na blokiću: lijevo račun, desno iznos. Mjesta u
           tekstu su `[broj]`, `[rijec]` i `[komad]`, iz istog razloga zbog
           kojeg ih ima poruka ankete: Shopify svaki `{{ … }}` u zadanoj
           vrijednosti postavke čita kao dinamički izvor i odbija predložak
           pri objavi. */
        var racunEl = $('[data-ukupno-racun]', ispis);
        var iznosEl = $('[data-ukupno-iznos]', ispis);
        var racun = (ispis.getAttribute('data-predlozak') || '')
          .replace('[broj]', String(kolicina))
          .replace('[rijec]', rijec)
          .replace('[komad]', novac(poKomadu));

        if (racunEl && iznosEl) {
          racunEl.textContent = racun;
          iznosEl.textContent = novac(poKomadu * kolicina);
        } else {
          /* Starija razmještaj bez dvaju polja — neka i tada nešto piše. */
          ispis.textContent = racun + ' = ' + novac(poKomadu * kolicina);
        }
        ispis.hidden = false;
      });
    }

    /* Stepper šalje `change`, tipkovnica `input`, a odabir varijante (i
       kvačica nadoplate kroz njega) svoj vlastiti događaj — sve vodi ovamo. */
    document.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'quantity') osvjezi();
    });
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.hasAttribute) return;
      if (e.target.name === 'quantity') osvjezi();
    });
    document.addEventListener('varijanta:promjena', osvjezi);

    osvjezi();
  }

  // ---------------------------------------------------------- odabir varijante

  /* KVAČICA NADOPLATE JE DIO ODABIRA VARIJANTE (8. 9. 2026.).

     Nadoplata „Nepropusni materijal” je vrijednost opcije „Materijal” sa
     sufiksom („Pamuk + nepropusni sloj”, 0,50 € skuplja). Pločice s tim
     sufiksom se ne crtaju (odabir-varijante.liquid); umjesto njih stoji
     kvačica `[data-nadoplata]` s indeksom opcije i sufiksom. Dok je
     uključena, odabranoj vrijednosti te opcije dodaje se sufiks, i dalje
     se traži obična varijanta — pa je nadoplata jedan redak u košarici,
     na blagajni, u mailu i u narudžbi, s nazivom koji sam kaže što se šije. */
  function dodatakForme(korijen) {
    var polje = $('[data-nadoplata]', korijen);
    if (!polje || !polje.hasAttribute('data-nadoplata-opcija')) return null;
    var indeks = parseInt(polje.getAttribute('data-nadoplata-opcija'), 10);
    if (isNaN(indeks)) return null;
    return { polje: polje, indeks: indeks, sufiks: polje.getAttribute('data-nadoplata-sufiks') || '' };
  }

  function vrijednostSDodatkom(dodatak, indeks, vrijednost) {
    if (!dodatak || !vrijednost || dodatak.indeks !== indeks || !dodatak.polje.checked) return vrijednost;
    return vrijednost + dodatak.sufiks;
  }

  /* Ista logika koju radi WooCommerce: kad se promijeni opcija, nađi varijantu
     koja odgovara SVIM odabranim vrijednostima, pa osvježi cijenu, sliku,
     dostupnost i skriveni id. */
  function odabirVarijante() {
    $$('[data-odabir-varijante]').forEach(function (korijen) {
      var podaciEl = $('[data-varijante-json]', korijen);
      if (!podaciEl) return;

      var varijante;
      try { varijante = JSON.parse(podaciEl.textContent); } catch (err) { return; }

      var idPolje = $('[name="id"]', korijen.closest('form') || korijen);
      var cijenaEl = $('[data-cijena-varijante]', korijen);
      var staraCijenaEl = $('[data-stara-cijena]', korijen);
      var gumb = $('[data-gumb-dodaj]', korijen.closest('form') || korijen);
      var dodatak = dodatakForme(korijen);

      function odabrane() {
        var v = [];
        $$('[data-opcija]', korijen).forEach(function (grupa) {
          var indeks = parseInt(grupa.getAttribute('data-opcija'), 10);
          var odabran = $('input:checked', grupa) || $('select', grupa);
          /* Prazan `<select>` („Odaberi opciju") znači „nije odabrano", ne
             vrijednost "". Bez ovoga bi se "" uspoređivao s vrijednostima
             varijante, nijedna kombinacija ne bi prošla i svi bi swatchevi
             ispali nedostupni — vidi se nakon klika na „Obriši". */
          v[indeks] = odabran && odabran.value ? vrijednostSDodatkom(dodatak, indeks, odabran.value) : null;
        });
        return v;
      }

      function potpuno(vrijednosti) {
        for (var i = 0; i < vrijednosti.length; i += 1) {
          if (vrijednosti[i] == null) return false;
        }
        return true;
      }

      // Dok sve opcije nisu odabrane, varijante nema — kao na originalu,
      // gdje je `variation_id` prazan, a gumb onemogućen.
      function nadi(vrijednosti) {
        if (!potpuno(vrijednosti)) return null;
        return varijante.filter(function (v) {
          return v.opcije.every(function (o, i) {
            return o === vrijednosti[i];
          });
        })[0] || null;
      }

      // Kombinacije kojih nema označimo, da kupac ne bira u prazno.
      function oznaciDostupnost(vrijednosti) {
        $$('[data-opcija]', korijen).forEach(function (grupa) {
          var indeks = parseInt(grupa.getAttribute('data-opcija'), 10);
          $$('input', grupa).forEach(function (ulaz) {
            var proba = vrijednosti.slice();
            var vrijednostUlaza = vrijednostSDodatkom(dodatak, indeks, ulaz.value);
            proba[indeks] = vrijednostUlaza;
            var postoji = varijante.some(function (v) {
              return v.opcije.every(function (o, i) {
                return i === indeks ? o === vrijednostUlaza : (proba[i] == null || o === proba[i]);
              }) && v.dostupna;
            });
            var oznaka = ulaz.closest('label') || ulaz.parentElement;
            if (oznaka) oznaka.classList.toggle('nije-dostupna', !postoji);
          });
        });
      }

      function osvjezi() {
        var vrijednosti = odabrane();
        var v = nadi(vrijednosti);
        oznaciDostupnost(vrijednosti);

        if (idPolje) idPolje.value = v ? v.id : '';

        // Bez odabrane varijante redak cijene nestaje — Woo mu stavlja
        // `display:none` na `.single_variation`. CSS skriva cijeli redak
        // (i sufiks) kad je ovo polje skriveno.
        if (cijenaEl) {
          cijenaEl.textContent = v ? novac(v.cijena) : '';
          cijenaEl.hidden = !v;
        }
        if (staraCijenaEl) {
          var imaStaru = v && v.staraCijena && v.staraCijena > v.cijena;
          staraCijenaEl.textContent = imaStaru ? novac(v.staraCijena) : '';
          staraCijenaEl.hidden = !imaStaru;
        }

        if (gumb) {
          var moze = v && v.dostupna;
          gumb.disabled = !moze;
          gumb.textContent = v
            ? (v.dostupna ? (sm.tekst.dodaj || 'Dodaj u košaricu') : (sm.tekst.nemaZalihe || 'Nema na zalihi'))
            : (sm.tekst.odaberiOpciju || 'Odaberi opciju');

          /* „Kupi odmah” mora pratiti isto stanje (22. 8. 2026.). Kombinacija
             koja ne postoji (npr. Bež + Pamučni frotir) ostavljala je taj gumb
             naizgled aktivnim; `kupiOdmah` bi na klik tiho odustao jer nema
             `id`, pa se kupcu činilo da gumb ne radi. Sada je vidljivo
             onemogućen, kao i „Dodaj u košaricu”. */
          var kupiGumb = korijen.querySelector('[data-kupi-odmah]');
          if (kupiGumb) kupiGumb.disabled = !moze;
        }

        // Slika se mijenja samo ako varijanta ima svoju — inače ostaje
        // galerija proizvoda, točno kao na staroj stranici.
        if (v && v.slika != null) prikaziSliku(korijen, v.slika);

        objavi('varijanta:promjena', { varijanta: v });

        if (v && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url);
        }
      }

      korijen.addEventListener('change', function (e) {
        if (e.target.closest('[data-opcija]') || e.target.hasAttribute('data-nadoplata')) osvjezi();
      });

      $$('[data-ocisti-opcije]', korijen).forEach(function (g) {
        g.addEventListener('click', function (e) {
          e.preventDefault();
          $$('input:checked', korijen).forEach(function (i) { i.checked = false; });
          $$('select', korijen).forEach(function (s) { s.selectedIndex = 0; });
          osvjezi();
        });
      });

      osvjezi();
    });
  }

  // Traka sličica je visoka točno koliko i glavna slika (tri vidljive), pa kod
  // proizvoda s više slika aktivna sličica ispadne iz vidnog polja — na
  // desktopu po visini, na mobitelu po širini. scrollIntoView bi ovdje povukao
  // i cijelu stranicu, zato pomak računamo sami: miče se samo traka.
  function pomakniTraku(slicica) {
    var traka = slicica.parentNode;
    if (!traka || !traka.getBoundingClientRect) return;
    var s = slicica.getBoundingClientRect();
    var t = traka.getBoundingClientRect();
    if (traka.scrollHeight > traka.clientHeight) {
      if (s.top < t.top) traka.scrollTop += s.top - t.top;
      else if (s.bottom > t.bottom) traka.scrollTop += s.bottom - t.bottom;
    }
    if (traka.scrollWidth > traka.clientWidth) {
      if (s.left < t.left) traka.scrollLeft += s.left - t.left;
      else if (s.right > t.right) traka.scrollLeft += s.right - t.right;
    }
  }

  // Odabir varijante zove ovo kad varijanta ima vlastitu sliku. Njemu je
  // korijen forma, a ne galerija, pa je tražimo od njega prema gore, a ako
  // je nema — prvu na stranici.
  function prikaziSliku(korijen, indeks) {
    var g = (korijen && korijen.closest && korijen.closest('[data-galerija]')) || $('[data-galerija]');
    if (g && g.smGalerijaIdi) g.smGalerijaIdi(parseInt(indeks, 10) || 0, true);
  }

  // ---------------------------------------------------------- galerija

  /* Galerija je vodoravni skroler sa snap točkama; JS drži usklađenima
     četiri stvari koje bi inače odlutale jedna od druge: aktivni slajd,
     aktivnu sličicu, brojač i stanje strelica.

     Uvećanja na prelazak mišem više nema. Palilo se na prvi `mousemove`,
     pa se slika trzala čim kupac uđe u galeriju, a kod proizvoda s dvadeset
     slika navigacija je postala nemoguća. Klik sada otvara povećalo, gdje
     uvećanje ima smisla i gdje se lista strelicama i tipkovnicom. */

  function galerija() {
    var mirno = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    $$('[data-galerija]').forEach(function (g) {
      var traka = $('[data-galerija-traka]', g);
      if (!traka) return;

      var slajdovi = $$('[data-slajd]', g);
      var slicice = $$('[data-slicica]', g);
      var skroler = $('[data-galerija-slicice]', g);
      var stupac = skroler ? skroler.parentNode : null;
      var prije = $('[data-galerija-prije]', g);
      var poslije = $('[data-galerija-poslije]', g);
      var tekuca = $('[data-galerija-tekuca]', g);
      var aktivan = 0;

      function oznaci() {
        slajdovi.forEach(function (s, i) { s.classList.toggle('je-aktivan', i === aktivan); });

        slicice.forEach(function (t, i) {
          var je = i === aktivan;
          t.classList.toggle('je-aktivna', je);
          t.setAttribute('aria-selected', je ? 'true' : 'false');
          t.tabIndex = je ? 0 : -1;
          if (je) pomakniTraku(t);
        });

        if (tekuca) tekuca.textContent = String(aktivan + 1);
        if (prije) prije.disabled = aktivan <= 0;
        if (poslije) poslije.disabled = aktivan >= slajdovi.length - 1;
      }

      // Sjena na dnu stupca sličica postoji samo dok ih stvarno ima još.
      function osvjeziSjenu() {
        if (!stupac || !skroler) return;
        var jos = skroler.scrollHeight - skroler.clientHeight - skroler.scrollTop > 8
          || skroler.scrollWidth - skroler.clientWidth - skroler.scrollLeft > 8;
        stupac.classList.toggle('ima-jos', jos);
      }

      function idi(i, pomakni) {
        if (i < 0 || i >= slajdovi.length) return;
        aktivan = i;
        oznaci();
        if (pomakni && traka.clientWidth) {
          traka.scrollTo({ left: i * traka.clientWidth, behavior: mirno ? 'auto' : 'smooth' });
        }
      }

      // Vanjska ručka — odabir varijante je zove kroz prikaziSliku().
      g.smGalerijaIdi = idi;

      g.addEventListener('click', function (e) {
        var t = e.target.closest('[data-slicica]');
        if (t) {
          e.preventDefault();
          idi(slicice.indexOf(t), true);
          return;
        }

        if (prije && e.target.closest('[data-galerija-prije]')) return idi(aktivan - 1, true);
        if (poslije && e.target.closest('[data-galerija-poslije]')) return idi(aktivan + 1, true);
      });

      // Prst i kotačić mijenjaju slajd bez ijednog klika — brojač i sličice
      // moraju to pratiti.
      var ceka = false;
      traka.addEventListener('scroll', function () {
        if (ceka) return;
        ceka = true;
        requestAnimationFrame(function () {
          ceka = false;
          if (!traka.clientWidth) return;
          var i = Math.round(traka.scrollLeft / traka.clientWidth);
          if (i !== aktivan && i >= 0 && i < slajdovi.length) {
            aktivan = i;
            oznaci();
          }
        });
      });

      traka.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); idi(aktivan - 1, true); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); idi(aktivan + 1, true); }
      });

      // Traka sličica je tablist: strelice pomiču odabir, Home/End na krajeve.
      if (skroler) {
        skroler.addEventListener('keydown', function (e) {
          var korak = 0;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') korak = -1;
          else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') korak = 1;
          else if (e.key === 'Home') return e.preventDefault(), idi(0, true), slicice[0].focus();
          else if (e.key === 'End') return e.preventDefault(), idi(slicice.length - 1, true), slicice[slicice.length - 1].focus();
          if (!korak) return;
          e.preventDefault();
          var sljedeci = Math.min(slicice.length - 1, Math.max(0, aktivan + korak));
          idi(sljedeci, true);
          slicice[sljedeci].focus();
        });

        skroler.addEventListener('scroll', function () { osvjeziSjenu(); });
        window.addEventListener('resize', osvjeziSjenu);
        osvjeziSjenu();
      }

      oznaci();
    });
  }

  // ---------------------------------------------------------- akordeon

  function akordeon() {
    document.addEventListener('click', function (e) {
      var glava = e.target.closest('.sm-akordeon__glava');
      if (!glava) return;
      var otvoren = glava.getAttribute('aria-expanded') === 'true';
      glava.setAttribute('aria-expanded', otvoren ? 'false' : 'true');
      var tijelo = document.getElementById(glava.getAttribute('aria-controls'));
      if (tijelo) tijelo.hidden = otvoren;

      // Akordeon označen s data-akordeon-jedno drži otvorenu samo jednu stavku.
      // Naslovnica ga NEMA — Elementorov toggle dopušta više otvorenih odjednom.
      var jedan = glava.closest('[data-akordeon-jedno]');
      if (!jedan || otvoren) return;

      $$('.sm-akordeon__glava', jedan).forEach(function (druga) {
        if (druga === glava) return;
        druga.setAttribute('aria-expanded', 'false');
        var drugoTijelo = document.getElementById(druga.getAttribute('aria-controls'));
        if (drugoTijelo) drugoTijelo.hidden = true;
      });
    });
  }

  // ---------------------------------------------------------- „pročitaj više”

  /* Tekst stegnut na N redaka + gumb koji ga otvara. Zatvoreno je zadano
     stanje — klijentica (18. 8. 2026.): recenzija koja završi s „…” a nema
     kako se otvoriti je kvar, ali ni cijela recenzija po zadanom ne valja
     jer je to opet zid teksta.

     Gumb u markupu stoji `hidden` i JS ga otkriva SAMO ako tekst stvarno
     prelijeva. Bez toga bi kratka recenzija nudila „pročitaj više” za redak
     koji se već cijeli vidi, a bez JS-a gumba jednostavno nema — tekst
     ostaje stegnut, kao i dosad.

     Ugovor markupa:
       [data-prosirivo]        korijen (kartica)
       [data-prosirivo-tekst]  stegnuti tekst
       [data-prosirivo-gumb]   gumb, s data-tekst-vise / data-tekst-manje
       .je-prosiren            stanje na korijenu

     Mjeri se na `scrollHeight` prema `clientHeight`, jer `-webkit-line-clamp`
     ne mijenja `scrollHeight`. Prag od 2 px pokriva zaokruživanje pri
     necjelobrojnoj visini retka. */

  function prosirivo() {
    var korijeni = $$('[data-prosirivo]');
    if (!korijeni.length) return;

    function izmjeri() {
      korijeni.forEach(function (korijen) {
        var gumb = $('[data-prosirivo-gumb]', korijen);
        var tekst = $('[data-prosirivo-tekst]', korijen);
        if (!gumb || !tekst) return;
        // Otvoren tekst se ne mjeri — stegnuta visina tada ne postoji.
        if (korijen.classList.contains('je-prosiren')) return;
        gumb.hidden = tekst.scrollHeight <= tekst.clientHeight + 2;
      });
    }

    document.addEventListener('click', function (e) {
      var gumb = e.target.closest('[data-prosirivo-gumb]');
      if (!gumb) return;
      var korijen = gumb.closest('[data-prosirivo]');
      if (!korijen) return;

      var otvoren = korijen.classList.toggle('je-prosiren');
      gumb.setAttribute('aria-expanded', otvoren ? 'true' : 'false');
      var natpis = otvoren ? gumb.getAttribute('data-tekst-manje') : gumb.getAttribute('data-tekst-vise');
      if (natpis) gumb.textContent = natpis;
    });

    izmjeri();

    // Prijelom se mijenja sa širinom i s učitanim pismom — oboje može
    // pretvoriti tri retka u dva i obrnuto.
    var cekaj;
    window.addEventListener('resize', function () {
      clearTimeout(cekaj);
      cekaj = setTimeout(izmjeri, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(izmjeri).catch(function () {});
  }

  // ---------------------------------------------------------- mobilni izbornik

  function izbornik() {
    var gumb = $('[data-otvori-izbornik]');
    var panel = $('[data-mobilni-izbornik]');
    if (!gumb || !panel) return;

    var okvir = $('.sm-mobilni-izbornik__panel', panel) || panel;
    var otpustiZamku = null;

    function prebaci(otvori) {
      if (otvori === panel.classList.contains('je-otvoren')) return;
      panel.classList.toggle('je-otvoren', otvori);
      gumb.setAttribute('aria-expanded', otvori ? 'true' : 'false');
      if (otvori) zakljucajPomak(); else otkljucajPomak();
      if (otvori) {
        // Fokus je dosad ostajao na burgeru, pa je sljedećih pet Tabova
        // prolazilo kroz zaglavlje IZA otvorenog izbornika.
        otpustiZamku = zamka(okvir, $('[data-zatvori-izbornik]', okvir));
      } else if (otpustiZamku) {
        otpustiZamku();
        otpustiZamku = null;
      }
    }

    gumb.addEventListener('click', function () {
      prebaci(!panel.classList.contains('je-otvoren'));
    });

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-zatvori-izbornik]') || e.target.hasAttribute('data-zastor')) prebaci(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('je-otvoren')) prebaci(false);
    });
  }

  // ---------------------------------------------------------- tražilica

  function trazilica() {
    var panel = $('[data-panel-trazilice]');
    if (!panel) return;
    var polje = $('input[type="search"]', panel);
    var izlaz = $('[data-rezultati-trazilice]', panel);

    var okvirTrazilice = $('.sm-panel-trazilice__okvir', panel) || panel;
    var otpustiZamku = null;

    function otvoriPanel() {
      if (!panel.hidden) return;
      panel.hidden = false;
      zakljucajPomak();
      otpustiZamku = zamka(okvirTrazilice, polje);
    }

    function zatvoriPanel() {
      if (panel.hidden) return;
      panel.hidden = true;
      otkljucajPomak();
      if (otpustiZamku) { otpustiZamku(); otpustiZamku = null; }
    }

    $$('[data-otvori-trazilicu]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        e.preventDefault();
        otvoriPanel();
      });
    });

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-zatvori-trazilicu]') || e.target.hasAttribute('data-zastor')) zatvoriPanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') zatvoriPanel();
    });

    if (!polje || !izlaz) return;

    var timer;
    polje.addEventListener('input', function () {
      clearTimeout(timer);
      var upit = polje.value.trim();
      // Woodmartova tražilica kretala je nakon 3 znaka (data-symbols_count="3",
      // spec kategorija.md §2.7) — držimo isti prag.
      if (upit.length < 3) { izlaz.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = rute.pretraga + '?q=' + encodeURIComponent(upit)
          + '&resources[type]=product&resources[limit]=8&section_id=prijedlozi-trazilice';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sadrzaj = doc.querySelector('[data-prijedlozi]');
          izlaz.innerHTML = sadrzaj ? sadrzaj.innerHTML : '';
        }).catch(function () {});
      }, 200);
    });
  }

  // ---------------------------------------------------------- filtri kolekcije

  /* Traka filtara je obična GET forma i radi i bez JS-a — gumb „Filter”
     je šalje, kao na staroj stranici. JS ovdje dodaje samo jedno: promjena
     sortiranja primjenjuje se odmah, jer kupac od padajućeg izbornika
     očekuje da nešto napravi, a ne da mora još kliknuti gumb.
     Kvačice filtara namjerno NE šaljemo automatski — na originalu se biralo
     više vrijednosti pa se tek onda potvrđivalo. */
  function filtriKolekcije() {
    $$('[data-filtri]').forEach(function (forma) {
      var odabir = $('[data-sortiranje]', forma);
      if (!odabir) return;
      odabir.addEventListener('change', function () { forma.submit(); });
    });
  }

  // ---------------------------------------------------------- „Kupi odmah”

  /* Isto što i dodavanje u košaricu, samo bez zaustavljanja na stranici:
     doda artikl pa vodi na blagajnu. Gumb može biti izvan forme (ljepljiva
     traka) — tada ga na formu veže atribut `form`. */
  function kupiOdmah() {
    document.addEventListener('click', function (e) {
      var gumb = e.target.closest('[data-kupi-odmah]');
      if (!gumb) return;
      var forma = gumb.form || gumb.closest('form');
      if (!forma) return;
      e.preventDefault();

      var idPolje = $('[name="id"]', forma);
      if (!idPolje || !idPolje.value) return;

      gumb.disabled = true;
      Kosarica.dodajStavke(stavkeIzForme(forma))
        .then(function () {
          window.location.href = (sm.korijen || '/').replace(/\/$/, '') + '/checkout';
        })
        .catch(function (err) {
          gumb.disabled = false;
          var greska = $('[data-greska-forme]', forma);
          if (greska) { greska.textContent = err.message; greska.hidden = false; }
        });
    });
  }

  // ---------------------------------------------------------- nedostupne opcije

  /* Swatcheve (radio gumbe) označava odabirVarijante. Padajući izbornik nema
     ulaza pa ga ne dohvaća — ovdje istim pravilom označavamo <option>. */
  function nedostupneOpcije() {
    $$('[data-odabir-varijante]').forEach(function (korijen) {
      var podaciEl = $('[data-varijante-json]', korijen);
      if (!podaciEl) return;

      var varijante;
      try { varijante = JSON.parse(podaciEl.textContent); } catch (err) { return; }

      var grupe = $$('[data-opcija]', korijen);
      if (!grupe.length) return;
      var dodatak = dodatakForme(korijen);

      function oznaci() {
        var odabrano = [];
        grupe.forEach(function (grupa) {
          var indeks = parseInt(grupa.getAttribute('data-opcija'), 10);
          var polje = $('input:checked', grupa) || $('select', grupa);
          odabrano[indeks] = polje && polje.value ? vrijednostSDodatkom(dodatak, indeks, polje.value) : null;
        });

        grupe.forEach(function (grupa) {
          var indeks = parseInt(grupa.getAttribute('data-opcija'), 10);
          $$('option', grupa).forEach(function (opcija) {
            if (!opcija.value) return;
            var vrijednostOpcije = vrijednostSDodatkom(dodatak, indeks, opcija.value);
            var postoji = varijante.some(function (v) {
              return v.dostupna && v.opcije.every(function (o, i) {
                return i === indeks ? o === vrijednostOpcije : (odabrano[i] == null || o === odabrano[i]);
              });
            });
            opcija.classList.toggle('nije-dostupna', !postoji);
          });
        });
      }

      korijen.addEventListener('change', function (e) {
        if (e.target.closest('[data-opcija]') || e.target.hasAttribute('data-nadoplata')) oznaci();
      });
      $$('[data-ocisti-opcije]', korijen).forEach(function (g) {
        g.addEventListener('click', function () { setTimeout(oznaci, 0); });
      });

      oznaci();
    });
  }

  // ---------------------------------------------------------- preporuke

  /* Zadnji korak lanca cross-sella: Shopify Recommendations API.
     Zove se samo ako Liquid nije uspio ništa prikazati, pa stranica
     ne čeka ovaj zahtjev da bi bila upotrebljiva. */
  function preporuke() {
    $$('[data-preporuke][data-treba-dohvatiti]').forEach(function (el) {
      var id = el.getAttribute('data-id-proizvoda');
      var granica = el.getAttribute('data-granica') || 4;
      if (!id) return;

      var url = sm.korijen.replace(/\/$/, '')
        + '/recommendations/products?section_id=preporuceni-proizvodi'
        + '&product_id=' + encodeURIComponent(id)
        + '&limit=' + encodeURIComponent(granica)
        + '&intent=related';

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var izvor = doc.querySelector('[data-mreza-preporuka]');
          var cilj = $('[data-mreza-preporuka]', el);
          if (!izvor || !cilj) return;
          if (!izvor.querySelector('.sm-kartica:not(.sm-kartica--kostur)')) {
            el.hidden = true;   // nema što preporučiti — ne prikazuj prazan naslov
            return;
          }
          cilj.innerHTML = izvor.innerHTML;
        })
        .catch(function () { el.hidden = true; });
    });
  }

  // ---------------------------------------------------------- ljepljiva traka proizvoda

  function ljepljivaTraka() {
    var traka = $('[data-ljepljiva-traka]');
    var sidro = $('[data-kraj-kupovine]');
    if (!traka || !sidro || !('IntersectionObserver' in window)) return;

    /* Traka se pokazuje tek kad gumb ostane IZNAD vidnog polja, dakle kad je
       kupac skrolao ispod njega. Sama "ne vidi se" nije dovoljna — gumb je
       pri učitavanju stranice ispod pregiba, a traka tada mora biti skrivena. */
    new IntersectionObserver(function (unosi) {
      var unos = unosi[0];
      traka.classList.toggle('je-vidljiva', !unos.isIntersecting && unos.boundingClientRect.top < 0);
    }).observe(sidro);
  }

  // ---------------------------------------------------------- karusel

  /* Karusel je čisti CSS scroll-snap. JavaScript samo dodaje strelice,
     točkice i automatsku rotaciju — bez biblioteke. Ako JS zakaže, traka
     se i dalje može pomicati prstom i kotačićem.

     Korak nije clientWidth nego razmak između dviju stavki × broj stavki u
     prikazu; inače bi se pomak i scroll-snap svađali oko piksela. */

  var karuseliZaOsvjeziti = [];

  function osvjeziKarusele() {
    karuseliZaOsvjeziti.forEach(function (f) { f(); });
  }

  function karuseli() {
    var mirno = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    $$('[data-karusel]').forEach(function (korijen) {
      var traka = $('[data-karusel-traka]', korijen);
      if (!traka) return;

      var prije = $('[data-karusel-prije]', korijen);
      var poslije = $('[data-karusel-poslije]', korijen);
      var tockice = $('[data-karusel-tockice]', korijen);
      var razmak = parseInt(korijen.getAttribute('data-karusel-auto'), 10) || 0;
      var pauzaHover = false;
      var zaustavljeno = false;
      var brojStranica = 1;

      function korak() {
        var stavke = traka.children;
        if (stavke.length < 2) return traka.clientWidth || 1;
        var stopa = stavke[1].offsetLeft - stavke[0].offsetLeft;
        if (stopa <= 0) return traka.clientWidth || 1;
        return stopa * Math.max(1, Math.round(traka.clientWidth / stopa));
      }

      function stranica() {
        return Math.round(traka.scrollLeft / korak());
      }

      function idi(i) {
        traka.scrollTo({ left: i * korak(), behavior: mirno ? 'auto' : 'smooth' });
      }

      function nacrtajTockice() {
        var oznaka = tockice.getAttribute('data-oznaka-stranice') || '';
        while (tockice.children.length > brojStranica) tockice.removeChild(tockice.lastChild);
        while (tockice.children.length < brojStranica) {
          var gumb = document.createElement('button');
          var broj = tockice.children.length;
          gumb.type = 'button';
          gumb.className = 'sm-karusel__tocka';
          gumb.setAttribute('data-karusel-tocka', broj);
          gumb.setAttribute('aria-label', (oznaka + ' ' + (broj + 1)).trim());
          tockice.appendChild(gumb);
        }
      }

      function osvjezi() {
        if (!traka.clientWidth) return;   // tab je skriven — ništa se ne mjeri
        var k = korak();
        brojStranica = Math.max(1, Math.ceil((traka.scrollWidth - 1) / k));
        var s = Math.min(stranica(), brojStranica - 1);

        if (prije) prije.disabled = s <= 0;
        if (poslije) poslije.disabled = s >= brojStranica - 1;

        if (!tockice) return;
        nacrtajTockice();
        tockice.hidden = brojStranica < 2;
        $$('[data-karusel-tocka]', tockice).forEach(function (t, i) {
          t.classList.toggle('je-aktivna', i === s);
          if (i === s) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }

      if (prije) prije.addEventListener('click', function () { zaustavljeno = true; idi(stranica() - 1); });
      if (poslije) poslije.addEventListener('click', function () { zaustavljeno = true; idi(stranica() + 1); });

      if (tockice) {
        tockice.addEventListener('click', function (e) {
          var t = e.target.closest('[data-karusel-tocka]');
          if (!t) return;
          zaustavljeno = true;
          idi(parseInt(t.getAttribute('data-karusel-tocka'), 10));
        });
      }

      var ceka = false;
      traka.addEventListener('scroll', function () {
        if (ceka) return;
        ceka = true;
        requestAnimationFrame(function () { ceka = false; osvjezi(); });
      });

      traka.addEventListener('pointerdown', function () { zaustavljeno = true; });
      window.addEventListener('resize', osvjezi);
      karuseliZaOsvjeziti.push(osvjezi);
      osvjezi();

      // Automatska rotacija (recenzije): pauza na prelazak mišem i na fokus,
      // trajno zaustavljanje nakon ručne interakcije — kao Swiper na originalu.
      if (razmak > 0 && !mirno) {
        korijen.addEventListener('mouseenter', function () { pauzaHover = true; });
        korijen.addEventListener('mouseleave', function () { pauzaHover = false; });
        korijen.addEventListener('focusin', function () { zaustavljeno = true; });

        setInterval(function () {
          if (pauzaHover || zaustavljeno || document.hidden || !traka.clientWidth) return;
          var s = stranica();
          idi(s >= brojStranica - 1 ? 0 : s + 1);
        }, razmak);
      }
    });
  }

  // ---------------------------------------------------------- tabovi

  /* Tabovi naslovnice. Sav sadržaj je već u DOM-u, prebacuje se atributom
     hidden — bez AJAX-a, bez skoka rasporeda. Tipkovnica: strelice, Home, End. */
  function tabovi() {
    $$('[data-tabovi]').forEach(function (korijen) {
      var gumbi = $$('[role="tab"]', korijen);
      if (gumbi.length < 2) return;

      function prikazi(indeks, fokusiraj) {
        gumbi.forEach(function (gumb, i) {
          var aktivan = i === indeks;
          gumb.setAttribute('aria-selected', aktivan ? 'true' : 'false');
          gumb.tabIndex = aktivan ? 0 : -1;
          var panel = document.getElementById(gumb.getAttribute('aria-controls'));
          if (panel) panel.hidden = !aktivan;
        });
        if (fokusiraj) gumbi[indeks].focus();
        osvjeziKarusele();
      }

      gumbi.forEach(function (gumb, i) {
        gumb.addEventListener('click', function () { prikazi(i, false); });

        gumb.addEventListener('keydown', function (e) {
          var zadnji = gumbi.length - 1;
          var cilj = -1;
          if (e.key === 'ArrowRight') cilj = i === zadnji ? 0 : i + 1;
          else if (e.key === 'ArrowLeft') cilj = i === 0 ? zadnji : i - 1;
          else if (e.key === 'Home') cilj = 0;
          else if (e.key === 'End') cilj = zadnji;
          if (cilj < 0) return;
          e.preventDefault();
          prikazi(cilj, true);
        });
      });
    });
  }

  // ---------------------------------------------------------- ankete

  /* Špil kartica: „Koliko uložaka trebam?” i „Koliko pelena trebam?”.

     Liquid je već iscrtao SVE ishode i sve proizvode, skrivene. Ovdje se
     ništa ne gradi i ništa se ne dohvaća — samo se otkriva ono što odgovara
     odgovorima i upisuju se brojevi. Tako nema ni jednog vanjskog zahtjeva,
     nema skoka rasporeda i anketa radi jednako brzo kao statička stranica.

     Aritmetika uložaka (`migracija/specifikacije/ankete.md` §1.5–1.6):
       setovi  ← 1. pitanje    2, 3, 4, 5, 6
       dan+noć ← 2. pitanje    6+1, 5+1, 4+1, 3+1
       ukupno  = setovi × (dan + noć)
       za dan  = setovi × dan   → pamuk
       za noć  = setovi × noć   → pamučni frotir

     Pelene su tablica 3 × 3 i ne računaju se — ključ ishoda je samo spoj
     dvaju odgovora. */

  var ANKETA_SETOVI = [2, 3, 4, 5, 6];
  var ANKETA_DNEVNO = [6, 5, 4, 3];
  var ANKETA_NOCNO = 1;

  /* Hrvatska množina: 21 uložak, 22–24 uloška, 25 uložaka, 11–14 uložaka. */
  function hrvatskiOblik(broj, jednina, malo, mnozina) {
    var stotina = broj % 100;
    if (stotina >= 11 && stotina <= 14) return mnozina;
    var jedinica = broj % 10;
    if (jedinica === 1) return jednina;
    if (jedinica >= 2 && jedinica <= 4) return malo;
    return mnozina;
  }

  function ankete() {
    $$('[data-anketa]').forEach(function (korijen) {
      var vrsta = korijen.getAttribute('data-anketa-vrsta');
      var ukupnoPitanja = parseInt(korijen.getAttribute('data-anketa-pitanja'), 10) || 2;
      var spil = $('[data-anketa-spil]', korijen);
      var hrpa = $('[data-anketa-hrpa]', korijen);
      var napredak = $('[data-anketa-napredak]', korijen);
      var rezultat = $('[data-anketa-rezultat]', korijen);
      if (!spil || !rezultat) return;

      var karte = {};
      $$('[data-anketa-karta]', spil).forEach(function (k) {
        karte[k.getAttribute('data-anketa-karta')] = k;
      });

      var odgovori = [];
      var trenutna = 'uvod';
      /* Je li rezultat već jednom bio na ekranu. Ako jest, izmjena jednog
         odgovora vraća ravno na njega umjesto da tjera kupca kroz preostala
         pitanja koja je već odgovorio. */
      var zavrseno = false;

      // ------------------------------------------------ prikaz karata

      /* Odlazeća karta se KLONIRA i animira iznad špila, a prava se odmah
         makne iz toka. Da su karte složene jedna preko druge u istoj ćeliji,
         špil bi cijelo vrijeme bio visok koliko najviša karta — a uvodna je
         upola niža od pitanja s pet odgovora. */
      function otpusti(stara, smjer) {
        if (!stara || !spil.animate) return;
        /* Tko je tražio manje gibanja ne dobiva klon uopće: bez ovoga bi
           420 ms stajao u DOM-u nevidljiv, a `prefers-reduced-motion` u CSS-u
           ne dodiruje trajanja Web Animations API-ja. */
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var kutija = stara.getBoundingClientRect();
        var omot = spil.getBoundingClientRect();
        var klon = stara.cloneNode(true);
        klon.hidden = false;
        klon.classList.add('sm-anketa__odlazi');
        klon.classList.remove('je-ziva');
        /* Klon je slika karte koja odlazi, ne karta. `inert` ga vadi i iz
           tabulatorskog reda i iz stabla pristupačnosti — bez toga bi
           tijekom animacije u dokumentu stajao drugi <h1> i drugi skup
           gumba, i Tab bi na pola sekunde vodio u ništa.
           `aria-hidden` ostaje za motore koji `inert` još ne poznaju. */
        klon.inert = true;
        klon.setAttribute('aria-hidden', 'true');
        klon.style.top = kutija.top - omot.top + 'px';
        klon.style.left = kutija.left - omot.left + 'px';
        klon.style.width = kutija.width + 'px';
        spil.appendChild(klon);

        var pomak = smjer === 'natrag' ? '18%' : '-18%';
        var zakret = smjer === 'natrag' ? '7deg' : '-7deg';
        var kraj = klon.animate(
          [
            { transform: 'none', opacity: 1 },
            { transform: 'translate(' + pomak + ', 7%) rotate(' + zakret + ') scale(.94)', opacity: 0 }
          ],
          { duration: 420, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'forwards' }
        );
        kraj.onfinish = function () { klon.remove(); };
        kraj.oncancel = function () { klon.remove(); };
      }

      function prikazi(kljuc, smjer, fokusiraj) {
        var stara = karte[trenutna];
        var nova = karte[kljuc];
        if (!nova || stara === nova) return;

        if (stara) {
          otpusti(stara, smjer);
          stara.hidden = true;
          stara.classList.remove('je-ziva');
        }

        nova.hidden = false;
        nova.classList.add('je-ziva');

        /* Ulazna animacija ide klasom koju dodaje JS, ne pravilom na
           `.je-ziva`: uvodna karta stoji u HTML-u kao živa i mora se
           obojiti odmah, bez 240 ms nevidljivosti prije prvog crtanja. */
        nova.classList.remove('je-dolazi');
        void nova.offsetWidth;
        nova.classList.add('je-dolazi');

        trenutna = kljuc;

        /* Koliko karata još stoji ispod — po tome se crta debljina špila. */
        var preostalo = ukupnoPitanja;
        if (kljuc === 'kraj') preostalo = 0;
        else if (kljuc !== 'uvod') preostalo = ukupnoPitanja - parseInt(kljuc, 10);
        spil.setAttribute('data-preostalo', Math.max(0, preostalo));

        if (fokusiraj !== false) nova.focus({ preventScroll: true });
      }

      // ------------------------------------------------ hrpa riješenih

      function crtajHrpu() {
        if (!hrpa) return;
        var ima = odgovori.length > 0;
        hrpa.hidden = !ima;

        $$('[data-anketa-listic]', hrpa).forEach(function (listic) {
          var i = parseInt(listic.getAttribute('data-anketa-listic'), 10);
          var odgovor = odgovori[i];
          listic.hidden = odgovor === undefined || odgovor === null;
          if (listic.hidden) return;
          var tekst = $('[data-anketa-listic-tekst]', listic);
          if (tekst) tekst.textContent = odgovor.oznaka;
        });

        if (napredak) {
          napredak.textContent = ima
            ? sm.tekst.anketaNapredak
                .replace('{{ broj }}', odgovori.length)
                .replace('{{ ukupno }}', ukupnoPitanja)
            : '';
        }
      }

      function oznaciOdabrano(indeks) {
        var karta = karte[String(indeks)];
        if (!karta) return;
        var odgovor = odgovori[indeks];
        $$('[data-anketa-odgovor]', karta).forEach(function (gumb) {
          var je = odgovor && String(odgovor.vrijednost) === gumb.getAttribute('data-anketa-odgovor');
          gumb.setAttribute('aria-pressed', je ? 'true' : 'false');
          gumb.classList.toggle('je-odabran', !!je);
        });
      }

      // ------------------------------------------------ izračun

      function napuni(kljuc, broj) {
        $$('[data-anketa-broj="' + kljuc + '"]', rezultat).forEach(function (el) {
          el.textContent = broj;
          var rijec = el.parentNode ? $('[data-anketa-rijec]', el.parentNode) : null;
          if (rijec) {
            rijec.textContent = hrvatskiOblik(
              broj,
              rijec.getAttribute('data-jednina'),
              rijec.getAttribute('data-malo'),
              rijec.getAttribute('data-mnozina')
            );
          }
        });
      }

      /* Količina putuje na stranicu proizvoda, ne u košaricu: boju i dezen
         bira kupac, a to anketa ne može zaključiti iz odgovora. */
      function stavka(grana, kljuc, broj) {
        var el = $('[data-anketa-stavka="' + kljuc + '"]', grana);
        if (!el) return 0;
        if (!broj || broj < 1) { el.hidden = true; return 0; }
        el.hidden = false;
        /* Jedan komad se ne broji — vidi `.je-jedan` u `sm-anketa.css`. */
        el.classList.toggle('je-jedan', broj === 1);

        var polje = $('[data-anketa-kolicina="' + kljuc + '"]', el);
        if (polje) polje.textContent = broj;

        var rijec = $('[data-anketa-rijec]', el);
        if (rijec) {
          rijec.textContent = hrvatskiOblik(
            broj,
            rijec.getAttribute('data-jednina'),
            rijec.getAttribute('data-malo'),
            rijec.getAttribute('data-mnozina')
          );
        }

        /* `data-anketa-url` od 22. 8. 2026. može već nositi `?variant=…`
           (anketa preporučuje veličinu, a veličina je varijanta). Slijepo
           dopisan `?` napravio bi `…?variant=123?kolicina=4` i Shopify bi
           odbacio i jedno i drugo. */
        $$('[data-anketa-veza]', el).forEach(function (veza) {
          var osnova = veza.getAttribute('data-anketa-url');
          if (!osnova) return;
          var spoj = osnova.indexOf('?') === -1 ? '?' : '&';
          veza.setAttribute('href', osnova + spoj + 'kolicina=' + broj);
        });
        return broj;
      }

      function otkrijSamo(izbor, odabrani) {
        $$(izbor, rezultat).forEach(function (el) {
          el.hidden = el !== odabrani;
        });
      }

      function izracunajUloske() {
        var setovi = ANKETA_SETOVI[odgovori[0].vrijednost] || 0;
        var dnevno = ANKETA_DNEVNO[odgovori[1].vrijednost] || 0;
        var zaDan = setovi * dnevno;
        var zaNoc = setovi * ANKETA_NOCNO;

        var grane = $$('[data-anketa-vel]', rezultat);
        var grana = grane[odgovori[2].vrijednost] || null;
        grane.forEach(function (g) { g.hidden = g !== grana; });

        napuni('zbroj', zaDan + zaNoc);
        napuni('dan_ukupno', zaDan);
        napuni('noc', zaNoc);

        var oznaka = $('[data-anketa-velicina]', rezultat);
        if (oznaka) oznaka.textContent = grana ? grana.getAttribute('data-anketa-oznaka') || '' : '';

        var tekstovi = $$('[data-anketa-velt]', rezultat);
        var tekst = tekstovi[odgovori[2].vrijednost] || null;
        tekstovi.forEach(function (t) { t.hidden = t !== tekst; });

        if (grana) {
          /* „Kombinirano” je jedini ishod s dva dnevna proizvoda: dnevna se
             količina dijeli, veći dio ide na veću veličinu. */
          var drugi = $('[data-anketa-stavka="dan2"]', grana);
          var imaDrugi = drugi && $('[data-anketa-veza]', drugi);
          if (imaDrugi) {
            var prvi = Math.ceil(zaDan / 2);
            stavka(grana, 'dan', prvi);
            stavka(grana, 'dan2', zaDan - prvi);
          } else {
            stavka(grana, 'dan', zaDan);
            stavka(grana, 'dan2', 0);
          }
          stavka(grana, 'noc', zaNoc);
        }

        var setovniki = $$('[data-anketa-set]', rezultat);
        otkrijSamo('[data-anketa-set]', setovniki[odgovori[0].vrijednost] || null);
        var kolicine = $$('[data-anketa-kol]', rezultat);
        otkrijSamo('[data-anketa-kol]', kolicine[odgovori[1].vrijednost] || null);
      }

      function izracunajPelene() {
        var kljuc = odgovori[0].vrijednost + '-' + odgovori[1].vrijednost;
        var grane = $$('[data-anketa-ishod]', rezultat);
        var grana = null;
        grane.forEach(function (g) {
          if (g.getAttribute('data-anketa-ishod') === kljuc) grana = g;
        });
        grane.forEach(function (g) { g.hidden = g !== grana; });
      }

      function otkrijRezultat() {
        if (odgovori.length < ukupnoPitanja) return;
        if (vrsta === 'ulosci') izracunajUloske();
        else izracunajPelene();

        spil.hidden = true;
        rezultat.hidden = false;
        zavrseno = true;
        rezultat.focus({ preventScroll: true });
        rezultat.scrollIntoView({ block: 'start', behavior: 'smooth' });
        objavi('anketa:rezultat', { vrsta: vrsta, odgovori: odgovori });
      }

      // ------------------------------------------------ događaji

      korijen.addEventListener('click', function (e) {
        var cilj = e.target;

        var kreni = cilj.closest('[data-anketa-kreni]');
        if (kreni) { prikazi('0', 'naprijed'); return; }

        var otkrij = cilj.closest('[data-anketa-otkrij]');
        if (otkrij) { otkrijRezultat(); return; }

        var ponovi = cilj.closest('[data-anketa-ponovi]');
        if (ponovi) {
          odgovori = [];
          zavrseno = false;
          rezultat.hidden = true;
          spil.hidden = false;
          $$('[data-anketa-odgovor]', spil).forEach(function (g) {
            g.setAttribute('aria-pressed', 'false');
            g.classList.remove('je-odabran');
          });
          Object.keys(karte).forEach(function (k) {
            karte[k].hidden = k !== 'uvod';
            karte[k].classList.toggle('je-ziva', k === 'uvod');
          });
          trenutna = 'uvod';
          spil.setAttribute('data-preostalo', ukupnoPitanja);
          crtajHrpu();
          spil.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }

        var listic = cilj.closest('[data-anketa-listic]');
        if (listic) {
          var natrag = listic.getAttribute('data-anketa-listic');
          if (!spil.hidden || rezultat.hidden === false) {
            rezultat.hidden = true;
            spil.hidden = false;
          }
          prikazi(natrag, 'natrag');
          return;
        }

        var gumb = cilj.closest('[data-anketa-odgovor]');
        if (!gumb) return;

        var karta = gumb.closest('[data-anketa-karta]');
        var indeks = parseInt(karta.getAttribute('data-anketa-karta'), 10);
        if (isNaN(indeks)) return;

        var tekstEl = $('.sm-anketa__odgovor-tekst', gumb) || $('.sm-anketa__plocica-tekst', gumb);
        odgovori[indeks] = {
          vrijednost: parseInt(gumb.getAttribute('data-anketa-odgovor'), 10),
          oznaka: tekstEl ? tekstEl.textContent.trim() : ''
        };
        oznaciOdabrano(indeks);
        crtajHrpu();

        /* Odgovorena karta odlazi odmah, ali ne prije nego što se odabir
           vidi — bez ovoga kupac ne zna je li klik uopće primljen. */
        var sljedeca = indeks + 1 < ukupnoPitanja ? String(indeks + 1) : 'kraj';
        setTimeout(function () { prikazi(sljedeca, 'naprijed'); }, 220);
      });

      crtajHrpu();
    });
  }

  /* Anketa preporuči broj komada i preda ga stranici proizvoda kroz
     `?kolicina=N`. Ovdje se taj broj upiše u polje količine i uz njega
     stoji rečenica zašto — inače polje pokazuje 18 bez ikakva objašnjenja. */
  function kolicinaIzAdrese() {
    var polje = $('[name="quantity"]');
    if (!polje) return;
    var trazeno = new URLSearchParams(window.location.search).get('kolicina');
    if (!trazeno) return;
    var broj = parseInt(trazeno, 10);
    if (isNaN(broj) || broj < 1) return;
    polje.value = Math.min(broj, 999);

    var poruka = $('[data-anketa-poruka]');
    if (!poruka) return;
    var predlozak = poruka.getAttribute('data-tekst') || '';
    /* Šest od devet ishoda ankete za pelene šalje `?kolicina=1`, pa bi bez
       sklonidbe primarni put te ankete završio na „preporučili smo ti
       1 komada”. Ista pravila kao u rezultatu ankete. */
    var rijec = hrvatskiOblik(
      parseInt(polje.value, 10),
      poruka.getAttribute('data-jednina') || '',
      poruka.getAttribute('data-malo') || '',
      poruka.getAttribute('data-mnozina') || ''
    );
    /* Mjesta u tekstu su `[broj]` i `[rijec]`, NE `{{ broj }}`.
       Shopify svaki `{{ … }}` u `default` vrijednosti postavke čita kao
       dinamički izvor (metafield) i odbija cijeli predložak pri objavi:
       „Dynamic source default value added to 'poruka_ankete' … is invalid”.
       Taj je kvar 18. 8. 2026. zaustavio objavu `templates/product.json`, a
       s njim i sve zajedničke kartice opisa.

       Stari zapis se i dalje prihvaća, jer je vlasnica mogla spremiti
       vlastitu poruku u uređivaču teme dok je zadana vrijednost još imala
       vitičaste zagrade. Ovdje se ništa ne gubi ako je koristi. */
    poruka.textContent = predlozak
      .replace('[broj]', polje.value)
      .replace('[rijec]', rijec)
      .replace('{{ broj }}', polje.value)
      .replace('{{ rijec }}', rijec);
    poruka.hidden = false;
  }

  // ---------------------------------------------------------- start

  function start() {
    ladica();
    forme();
    kolicineUKosarici();
    napomenaLadice();
    stranicaKosarice();
    steperi();
    odabirVarijante();
    pratiVidljivoOkno();
    nedostupneOpcije();
    ukupnoZaKolicinu();
    kupiOdmah();
    galerija();
    akordeon();
    prosirivo();
    karuseli();
    tabovi();
    izbornik();
    trazilica();
    filtriKolekcije();
    preporuke();
    ljepljivaTraka();
    ankete();
    kolicinaIzAdrese();

    document.addEventListener('kosarica:promjena', function (e) {
      osvjeziBrojac(e.detail);
      crtajTrakuDostave(e.detail);
    });

    Kosarica.dohvati().catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
